/* 店铺类型&合作类型&标签全局混入 */
import { mapState } from "vuex";

export default {
  name: "shop-type-map",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      shopTypeDataMap: state => state.app.shopTypeDataMap,
      shopTypeDataObjMap: state => state.app.shopTypeDataObjMap
    })
  },
  methods: {
    getShopTypeLabel(shopType) {
      console.log(
        "🚀 ~ getShopTypeLabel ~ this.shopTypeDataObjMap:",
        this.shopTypeDataObjMap
      );
      const name = this.shopTypeDataObjMap.shopCategory[shopType];
      // const name = `啦啦${this.shopTypeDataObjMap.shopCategory[shopType]}`
      return name && name.length > 2 ? name : `${name}店`;
    }
  }
};
